import React, { useContext } from 'react';
import Head from 'next/head';
import { ApartmentComplex } from 'schema-dts';
import { BuildingPageContextInterface } from 'apolloClient/types/Building';
import { BuildingPageContext } from 'pages/[urlParam]/[urlBuildParam]';

const BuildingAppartmentComplexSchema: React.FC = () => {
  const { building, url } = useContext(
    BuildingPageContext
  ) as BuildingPageContextInterface;

  const image = building.mainImage?.data?.attributes?.url;

  const appartment: ApartmentComplex = {
    '@type': 'ApartmentComplex',
    address: building.primaryAddress,
    image,
    name: building.name,
    url,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: building.lat,
      longitude: building.lon,
      address: building.primaryAddress,
      url,
      image,
      name: building.name,
    },
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    ...appartment,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Head>
  );
};

export default BuildingAppartmentComplexSchema;
